import { ZAuthRole } from '@/authority/authType';
import { ReactComponent as AuthorityIcon } from '@assets/image/iqsIcon/Authority.svg';
import { ReactComponent as DashboardIcon } from '@assets/image/menuIcon/Dashboard.svg';
import { ReactComponent as RoleManagementIcon } from '@assets/image/menuIcon/GroupAdd.svg';
import { ReactComponent as AnnouncementListIcon } from '@assets/image/menuIcon/Marketing.svg';
import { ReactComponent as ProjectListIcon } from '@assets/image/menuIcon/NavigationApps.svg';
import { POWER_BI_URL, POWER_BI_URL_2 } from '@constants';
import AnnouncementDetails from '@views/pages/AnnouncementDetails';
import AnnouncementList from '@views/pages/AnnouncementList';
import RoleManagementList from '@views/pages/RoleManagement';
import ProjectList from '@views/pages/projectList';
import ProjectDetail from '../views/pages/ProjectDetails';
import { routerListTS } from './types';

export const DashboardText = 'Dashboard(直销)';
export const DashboardDealerText = 'Dashboard(经销)';
export const DashboardDealer = 'Dashboard';

const authList: routerListTS[] = [
  {
    path: 'announcement',
    name: '公告列表',
    // auth: [ZAuthRole.Home],
    // auth: [ZAuthRole.noticeList],
    icon: <AnnouncementListIcon />,
    component: <AnnouncementList />
  },
  {
    path: 'projectList',
    name: '项目列表',
    // auth: [ZAuthRole.Home],
    // auth: [ZAuthRole.noticeList],
    icon: <ProjectListIcon />,
    component: <ProjectList />
  },
  {
    path: '/projectList/projectDetail',
    name: '项目详情',
    hideInMenu: true,
    icon: <AuthorityIcon />,
    component: <ProjectDetail />
  },
  {
    path: 'roleManagement',
    name: '角色管理',
    auth: [ZAuthRole.roleManagement],
    icon: <RoleManagementIcon />,
    component: <RoleManagementList />
  },
  {
    path: '/announcement/announcementDetail',
    name: '公告详情',
    hideInMenu: true,
    // auth: [ZAuthRole.Home],
    icon: <AuthorityIcon />,
    component: <AnnouncementDetails />
  },
  {
    path: POWER_BI_URL,
    name: DashboardText,
    // auth: [ZAuthRole.roleManagement],
    icon: <DashboardIcon />,
    // component: <RoleManagementList />
    outLink: true
  },
  {
    path: POWER_BI_URL_2,
    name: DashboardDealerText,
    // auth: [ZAuthRole.roleManagement],
    icon: <DashboardIcon />,
    // component: <RoleManagementList />
    outLink: true
  },
  {
    path: POWER_BI_URL_2,
    name: DashboardDealer,
    // auth: [ZAuthRole.roleManagement],
    icon: <DashboardIcon />,
    // component: <RoleManagementList />
    outLink: true
  }
];
export default authList;
